import { z } from "zod";
import { IsoTimestamp, PlayerId } from "./ids.js";

// Supabase `players` row (KICKOFF §4.1). MSISDN is never stored raw — hash only.
export const Player = z.object({
  id: PlayerId,
  msisdn_hash: z.string().min(1),
  gamertag: z.string().min(2).max(24),
  badge_id: z.string().min(1), // COLOURS badge, e.g. "badge_b4_std" — BLG identity (FINAL WHISTLE ratification ① pending, built to BLG badge)
  avatar_id: z.string().min(1), // GAFFERS avatar, e.g. "av_g2_std"
  founder: z.boolean(),
  ea_gamertag: z.string().min(1),
  ea_friend_code: z.string().min(1).nullable(),
  division: z.number().int().min(1),
  confidence: z.number().int().min(0),
  coins: z.number().int().min(0),
  created_at: IsoTimestamp,
});
export type Player = z.infer<typeof Player>;

// ── ELO constants (BK, 28 Jul) ───────────────────────────────────────────────
//
// In contracts because TWO packages have to agree on them: the engine that
// applies the maths, and the player app's Rating FAQ that explains it. When the
// FAQ owned its own copy, a K-factor change could leave the app telling players
// a number the engine had stopped using — and that FAQ is the screen someone
// opens when they think the system has treated them unfairly, which is the
// worst possible place to be quietly out of date.
//
// The player app must NOT import from services/. Sharing through contracts is
// the only direction that does not break the package boundary.

/** Every player starts here. BK: `players[player_id] = {'rating': 1200}`. */
export const STARTING_RATING = 1200;

/** BK: `k=32`. The most a single match can move a rating, in either direction. */
export const K_FACTOR = 32;
